import { render, staticRenderFns } from "./AutomatedEmailSection.vue?vue&type=template&id=617326b3&scoped=true"
import script from "./AutomatedEmailSection.vue?vue&type=script&lang=js"
export * from "./AutomatedEmailSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617326b3",
  null
  
)

export default component.exports